import classNames from 'classnames';
import type { ReactNode } from 'react';

import './Heading.scss';

const DEFAULT_SIZE = 'huge' as const;
const SUPPORTED_SIZES = ['huge', 'large', 'medium', 'small'] as const;
const DEFAULT_TAG = 'h1' as const;
const SUPPORTED_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

type HeadingProps = {
  id?: string;
  children?: ReactNode;
  as?: (typeof SUPPORTED_TAGS)[number];
  size?: (typeof SUPPORTED_SIZES)[number];
  className?: string;
};

const Heading = ({
  children,
  as = DEFAULT_TAG,
  size = DEFAULT_SIZE,
  className,
  ...props
}: HeadingProps) => {
  const Element = as;
  if (!SUPPORTED_TAGS.includes(Element)) {
    throw new Error('Unsupported type');
  }

  return (
    <Element
      className={classNames(`Heading Heading--${size}`, className)}
      {...props}
    >
      {children}
    </Element>
  );
};

export { Heading };
